import type { IInfiniteHfResponse } from "../../types";

import type { IMetaOption } from "@/interfaces";
import { Typography } from "@/components/atoms/typography";

export function HFItem(props: IMetaOption<IInfiniteHfResponse>) {
  const { name, type } = props;

  return (
    <div>
      <Typography
        fontWeight={"medium"}
        fontFamily={"dana"}
        fontSize={"md-high"}
      >
        {name}
      </Typography>
      <Typography
        fontFamily={"dana"}
        fontSize={"xs"}
        fontWeight={"regular"}
        variant={"caption1"}
      >
        {type.value}
      </Typography>
    </div>
  );
}
